module.exports = __webpack_public_path__ + "odinstatic/media/operator.6dad6524.svg";